/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Share_ExpiresInputs */

const en_share_expires = /** @type {(inputs: Share_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`expires on ${i?.date}`)
};

const de_share_expires = /** @type {(inputs: Share_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`läuft ab am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "expires on {date}" |
*
* @param {Share_ExpiresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_expires = /** @type {((inputs: Share_ExpiresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ExpiresInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_expires(inputs)
	return en_share_expires(inputs)
});